import axios from "axios";

export const BEVERAGE_MENU_TTL_MS = 60 * 1000;
const MENU_REQUEST_TIMEOUT_MS = 30000;
let cachedBeverageMenu = null;
let cachedMenuKey = "";
let cacheExpiresAt = 0;
let pendingBeverageMenu = null;
let pendingMenuKey = "";

export function getMenuKey(apiUrl) {
  return `${apiUrl}|${axios.defaults.headers.common.Authorization || ""}`;
}

export async function loadBeverageMenu(apiUrl, force = false) {
  const key = getMenuKey(apiUrl);
  if (!force && cachedBeverageMenu && cachedMenuKey === key && Date.now() < cacheExpiresAt) {
    return cachedBeverageMenu;
  }
  // A forced refresh also shares an existing request for the same session.
  if (pendingBeverageMenu && pendingMenuKey === key) return pendingBeverageMenu;

  const request = axios
    .get(`${apiUrl}Transaction/getDataBeverageMenu`, { timeout: MENU_REQUEST_TIMEOUT_MS })
    .then((res) => {
      if (res.data?.status === 0 && pendingBeverageMenu === request && getMenuKey(apiUrl) === key) {
        cachedBeverageMenu = res.data;
        cachedMenuKey = key;
        cacheExpiresAt = Date.now() + BEVERAGE_MENU_TTL_MS;
      }
      return res.data;
    })
    .finally(() => {
      if (pendingBeverageMenu === request) {
        pendingBeverageMenu = null;
        pendingMenuKey = "";
      }
    });
  pendingBeverageMenu = request;
  pendingMenuKey = key;
  return request;
}

export function prefetchBeverageMenu(apiUrl) {
  const key = getMenuKey(apiUrl);
  if ((cachedBeverageMenu && cachedMenuKey === key && Date.now() < cacheExpiresAt) ||
      (pendingBeverageMenu && pendingMenuKey === key)) return;
  loadBeverageMenu(apiUrl).catch(() => {});
}
